import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MenuItem, Typography, Box } from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import PublicIcon from "../assets/world.png";
import PublicIcon from "@mui/icons-material/Language";
import { StyledMenu } from "../utils/CustomTagComponents";
import SmartButton from "./common/SmartButton";
import { setCountryAction } from "../store/actions/AuthActions";
import { getCountriesDropdown } from "../services/CountryService";
import { useCountry } from "../context/CountryContext";
import { Popper, Paper, ClickAwayListener } from "@mui/material";

const CountryDropdown = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();

  const { countries, hasMore, loading, page, setPage, fetchCountries } =
    useCountry(); // ✅ shared state
  const { country_id: selectedCountryId } = useSelector(
    (state) => state.auth || {}
  );

  const open = Boolean(anchorEl);
  const observerRef = useRef(); // 👀 for detecting scroll bottom

  const handleClick = (event) =>
    setAnchorEl(anchorEl ? null : event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  // ✅ Scroll observer (detect bottom and load more)
  const handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 2;

    if (bottom && hasMore && !loading) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchCountries(nextPage);
    }
  };

  const handleSelectCountry = (countryId, countryLabel) => {
    dispatch(setCountryAction(countryId, countryLabel));
    handleClose();
  };

  const selectedCountry =
    countries.find((c) => c.id === selectedCountryId) || null;

  return (
    <Box>
      {/* ✅ Desktop Button */}
      <SmartButton
        sx={{
          display: { xs: "none", sm: "inline-flex" },
          alignItems: "center",
          justifyContent: "space-between",
          height: "45px",
          p: "9px",
          textTransform: "none",
          overflow: "hidden",
          borderRadius: "8px",
        }}
        onClick={handleClick}
        endIcon={
          <PublicIcon />
        }
      >
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: 700,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            lineHeight: "normal",
          }}
          title={selectedCountry ? selectedCountry.name : "Country"}
        >
          {selectedCountry ? selectedCountry.name : "Country"}
        </Typography>
      </SmartButton>

      {/* ✅ Mobile Icon */}
      <Box
        sx={{
          display: { xs: "inline-flex", sm: "none" },
          backgroundColor: "#fd0000",
          borderRadius: 1,
          p: 1,
          cursor: "pointer",
          "&:hover": { backgroundColor: "#fd0000" },
        }}
        onClick={handleClick}
      >
        <PublicIcon sx={{ color: 'white' }} />
      </Box>

      {/* ✅ Dropdown Menu */}
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        modifiers={[
          {
            name: "offset",
            options: {
              offset: [0, 0],
            },
          },
        ]}
        style={{ zIndex: 1300 }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper
            sx={{
              width: "180px",
              maxHeight: "250px",
              overflowY: "auto",
              borderRadius: "10px",

              // ✅ Important for dropdown look
              background: "#fff",
              boxShadow: "0px 10px 30px rgba(0,0,0,0.15)",
              border: "1px solid #eee",

              // ✅ remove red look
              p: 1,

              "&::-webkit-scrollbar": { width: "5px" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#ccc",
                borderRadius: "10px",
              },
            }}
            onScroll={handleScroll}
          >
            {countries.map((country) => (
              <MenuItem
                key={country.id}
                onClick={() => handleSelectCountry(country.id, country.name)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  height: "40px",
                  borderRadius: "5px",
                  color: country.id === selectedCountryId ? "#fff" : "#000",
                  backgroundColor:
                    country.id === selectedCountryId ? "#fd0000" : "#fff",
                  "&:hover": { backgroundColor: "#fd0000", color: "#fff" },
                }}
              >
                <Typography
                  sx={{
                    fontSize: "15px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    width: "100px",
                    color: "inherit",
                  }}
                  title={country.name}
                >
                  {country.name}
                </Typography>
              </MenuItem>
            ))}

            {loading && <MenuItem disabled>Loading...</MenuItem>}
          </Paper>
        </ClickAwayListener>
      </Popper>
    </Box>
  );
};

export default CountryDropdown;
